module.exports = __webpack_public_path__ + "img/1dcw.2fdfa6de.gif";